import React from "react";
import { Typography, Grid } from "@material-ui/core";
import intl from "react-intl-universal";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid,
} from "recharts";

import { IWithballData } from "apis";
import { BAR_COLOR } from "MuiProvider/colors";

import { ASPECT, CHART_WIDTH, BAR_SIZE } from "./constants";

interface IDribbleRankingProps {
  data: IWithballData[];
}

export const DribbleRanking = ({ data }: IDribbleRankingProps) => {
  if (!data || data.length === 0) {
    return null;
  }

  const groupedByPlayer = data.reduce((accumulator: any, rawData) => {
    if (!rawData.succeed || rawData.fromPlayer === -1) {
      return accumulator;
    }
    if (!accumulator[rawData.fromPlayer.toString()]) {
      accumulator[rawData.fromPlayer.toString()] = {
        playerId: rawData.fromPlayer,
        playerName: rawData.fromName,
        value: 0,
      };
    }
    accumulator[rawData.fromPlayer.toString()].value += 1;
    return accumulator;
  }, {});

  const chartData = Object.getOwnPropertyNames(groupedByPlayer).map(
    (property) => {
      return groupedByPlayer[property];
    }
  );

  return (
    <Grid container spacing={2}>
      {chartData.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h4">{`${intl.get(
            "TEAM_DASHBOARD_ANNUAL_PLAYER_DRIBBLE"
          )}`}</Typography>
          <ResponsiveContainer width={CHART_WIDTH} aspect={ASPECT}>
            <BarChart
              data={chartData}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="playerName" angle={-45} interval={0} />
              <YAxis />
              <Tooltip />
              <CartesianGrid strokeDasharray="3 3" />
              <Bar dataKey="value" fill={BAR_COLOR.total} barSize={BAR_SIZE} />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
      )}
    </Grid>
  );
};
